import {ProductInterface} from "../../interfaces/product/ProductInterface";
import {ProductPropertyInterface} from "../../interfaces/product/ProductPropertyInterface";
import BrandInfo from "./BrandInfo";

export default function Description({product}: {product:ProductInterface}) {


    return (<div
        className="flex-column flex-lg-row gap-4 fade justify-content-between prod-pane  active show"
       >
        <div className="d-flex flex-column prod-pane__left">
            <div className="prod-pane__text">
                <p className="fw-bold text-uppercase">Описание</p>
                <div dangerouslySetInnerHTML={{__html: product.additional_params?.description?.replace(/<table>/, '<table class="table">')?.replace(/\/public\/upload\//, 'https://www.pride.ru/public/upload/')}}></div>
            </div>
        </div>
        <BrandInfo product={product} />
    </div>)
}